import React, { useEffect, useState, useRef } from "react"
import Container from 'react-bootstrap/Container';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import 'react-day-picker/dist/style.css';
import { apiCallAdmin } from '../../services/api-service';
import { useLocation } from "react-router-dom";
import { useNavigate } from "react-router-dom";
import Header from "../common/Header.js";
import LoaderModal from "../common/Loader.js";
import { ReactComponent as ProfileIcon } from "../../assets/svg/profile-icon.svg";
import { useGlobal } from "../../GlobalContext.js";

export default function ProfileView() {
  const { selectedMenu, setSelectedMenu } = useGlobal();
  const apiUrl = process.env.REACT_APP_API_URL;
  const accountsUrl = process.env.REACT_APP_ACCOUNTS_URL;

  const navigate = useNavigate();
  const location = useLocation();
  const { id, date, formatted_date, } = location.state || {};
  const scrollRefs = useRef();

  const scrollLeft = () => {
    const ref = scrollRefs.current;
    if (ref) {
      ref.scrollBy({ left: -100, behavior: "smooth" });
    }
  };

  const scrollRight = () => {
    const ref = scrollRefs.current;
    if (ref) {
      ref.scrollBy({ left: 100, behavior: "smooth" });
    }
  };

  const [selectedOffice, setOfficeValue] = useState('');
  const [selectedFloor, setFloorValue] = useState('');
  const handleDropdownChange = (value) => {
    setOfficeValue(value);

  };

  const [showPicker, setShowPicker] = useState(false);


  const [profileDetails, setProfileDetail] = useState({});
  const [selectedSlotPeriod, setSelectedSlotPeriod] = useState('');
  const [selectedPeriodFrom, setSelectedPeriodFrom] = useState('');
  const [selectedPeriodTo, setSelectedPeriodTo] = useState('');
  const [errorMessage, setErrorMessage] = useState('');
  const [customSlotErrorMessage, setCustomSlotErrorMessage] = useState({ date: '', from: '', to: '', });

  const [selectedCategory, setCategoryValue] = useState('');
  const [selectedSlot, setSlotValue] = useState('30 mins');
  const [selectedBookId, setBookId] = useState([]);

  const [categoryList, setCategory] = useState([]);

  const [floorList, setFloors] = useState([]);
  const [roomList, setRooms] = useState([]);
  const [isOpen, setIsOpen] = useState(false);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  const openModal = (id) => {

    setIsOpen(true);
  };
  const closeModal = () => setIsOpen(false);
  const [selectedRoomId, setRoomId] = useState(-1);
  const [selectedRoomIndex, setRoomIndex] = useState(-1);
  const [availableList, setAvailable] = useState(['Ac', 'Projector', 'TV & Speaker']);
  const [slotList, setSlotList] = useState([]);
  const [startTimeInputValue, setStartTimeInputValue] = useState("");
  const [endTimeInputValue, setEndTimeInputValue] = useState("");
  const [startTime12HourInputValue, setStartTime12HourInputValue] = useState("");
  const [endTime12HourInputValue, setEndTime12HourInputValue] = useState("");


  const alertRef = useRef(null);
  const [profileImage, setProfileImage] = useState(null);
  const handleClickOutside = (event) => {

    if (alertRef.current && !alertRef.current.contains(event.target)) {
      setIsOpen(false);
    }
  };
  useEffect(() => {
    // Attach event listener to the document
    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      // Clean up event listener on unmount
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);
  const menuBoxInactive = { width: '128px', height: '44px', display: 'flex', justifyContent: "center", alignItems: "center", };
  const menuBoxActive = { width: '128px', height: '44px', display: 'flex', justifyContent: "center", alignItems: "center", borderBottom: "3px solid #842234", };
  const menuColorActive = { fontSize: "15px", fontWeight: "700", lineHeight: "17.17px", color: '#842234', };
  const menuColorInactive = { fontSize: "15px", fontWeight: "400", lineHeight: "17.17px", color: '#1E1E1E', };
  const profileName = { fontSize: "14px", fontWeight: "700", color: '#842234', };
  const title = { fontSize: "32px", fontWeight: "700", color: '#1E1E1E', };
  const subtitle = { fontSize: "15px", fontWeight: "400", color: '#81878C', };
  const roomTitle = { fontSize: "18px", fontWeight: "500", color: '#1E1E1E', };
  const seatCount = { fontSize: "13.5px", fontWeight: "400", color: '#81878C', marginTop: '8px', };
  const availableTitle = { fontSize: "12px", fontWeight: "400", color: '#81878C', marginBottom: '8px', };
  const availableName = { fontSize: "12.5px", fontWeight: "400", color: '#21272C' };
  const slotTitle = { fontSize: "13px", fontWeight: "700", color: '#1E1E1E' };
  const slotTitleSelected = { fontSize: "12px", fontWeight: "500", color: '#842234' };
  const filterTitle = { fontSize: "24px", fontWeight: "700", color: '#1E1E1E' };
  const officeTitle = { marginTop: '16px', marginBottom: '8px', fontSize: "15px", fontWeight: "700", lineHeight: "17.17px", color: '#1E1E1E', };
  const modalStyle = {
    overlay: {
      position: "fixed",
      top: 0,
      left: 0,
      right: 0,
      bottom: 0,
      backgroundColor: "rgba(0, 0, 0, 0.5)",
      opacity: 1,
      display: "flex",
      justifyContent: "center",
      alignItems: "center",

    },
    modal: {
      backgroundColor: "#ffffff",
      padding: "40px",
      borderRadius: "16px",
      boxShadow: "0 4px 6px rgba(0, 0, 0, 1)",
      width: "436px",
      height: "228px",
      textAlign: "center",
    },
  };
  useEffect(() => {
    // Attach event listener to the document
    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      // Clean up event listener on unmount
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);

  const handleCategoryClick = (category) => {
    setCategoryValue(category);

  };



  useEffect(() => {
    setSelectedMenu("Discover");
    fetchOptions();



  }, []);

  useEffect(() => {
    if (startTimeInputValue !== "" && endTimeInputValue !== "") {

    }
  }, [startTimeInputValue, endTimeInputValue]);

  const fetchOptions = async () => {
    setLoading(true);
    setError(null);

    try {
      const response = await apiCallAdmin("get", "profile");

      if (response?.data?.success === true) {
        console.log("booking:", response.data.user);
        setProfileDetail(response.data.user ?? {});


      }
      console.log("Room List:", roomList);
      console.log("Room List Length:", roomList.length);
    } catch (err) {
      console.error("Error fetching options:", err);
      setError("Failed to fetch options. Try again.");
    } finally {
      setLoading(false);
    }
  };






  useEffect(() => {

  }, [profileDetails]);
  useEffect(() => {

  }, [selectedSlot]);

  function convertTo12HourFormat(time24) {
    // Split the time string into hours and minutes
    const [hours24, minutes] = time24.split(":");

    // Convert to a number and calculate 12-hour format
    const hours = parseInt(hours24, 10) % 12 || 12; // Convert 0 to 12 for midnight
    const period = parseInt(hours24, 10) >= 12 ? "PM" : "AM";

    // Return formatted time
    return `${hours}:${minutes} ${period}`;
  }

  return (<Container fluid className="GTWalsheimTrial px-0">

    {/*  <Header selectedTab={'Discover'}/>   */}
    <Row className="flex-wrap px-3" style={{ height: 'calc(100vh - 68px)', overflow: 'auto', scrollbarWidth: "none", msOverflowStyle: "none", justifyContent: 'center', }}>

      <Col xl={8} style={{ padding: '16px', justifyContent: 'center', }}>

        &nbsp;&nbsp;
        <div style={{ padding: "16px", borderRadius: "24px", background: '#ffffff', display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center', }}>
          <div style={{ width: '140px', height: '140px', display: 'flex', alignItems: 'center', justifyContent: 'center', borderRadius: '100px', background: '#FEF0F2' }}>
            {profileImage === null && (<div>
              <ProfileIcon />
              <div>


              </div>

            </div>)}
            {profileImage !== null && (
              <div style={{ position: "relative", }}>
                <img src={profileImage} alt="Selected" style={{ width: '140px', height: '140px', objectFit: "cover", borderRadius: '100px', }} />
                {/*  'cover', 'contain', or 'fill' */}

              </div>
            )}

          </div>
          <div style={{ fontSize: "20px", fontWeight: "800", color: '#1E1E1E' }} >
            {profileDetails['first_name'] ?? ''}{' '}{profileDetails['last_name'] ?? ''}
          </div>
          <div style={{ fontSize: "14px", fontWeight: "400", color: '#81878C' }} >
            {profileDetails['email'] ?? ''}
          </div>
          <div style={{ height: '24px', marginTop: '8px', marginBottom: '4px', paddingLeft: '8px', paddingRight: '8px', borderRadius: '6px', display: 'flex', justifyContent: "center", alignItems: "center", backgroundColor: '#F5F7F9' }}>
            <div style={{ fontSize: "12px", fontWeight: "400", color: '#21272C' }}>Emp. ID : </div>  <div style={{ fontSize: "12px", fontWeight: "700", color: '#21272C' }}>{profileDetails['employee_id'] ?? ''}</div>
          </div>



        </div>
        &nbsp;&nbsp;
        <div style={{ padding: "16px", borderRadius: "24px", background: '#ffffff', }}>
          <div style={{ fontSize: "16px", fontWeight: "700", color: '#1E1E1E' }} >
            Organization details
          </div>
          <div style={{ marginTop: '8px', fontSize: "13px", fontWeight: "400", color: '#81878C' }} >
            Mobile number
          </div>
          <div style={{ marginTop: '4px', fontSize: "14px", fontWeight: "500", color: '#1E1E1E' }} >
            {profileDetails['contact_number'] ?? '---'}
          </div>

          <div style={{ marginTop: '8px', fontSize: "13px", fontWeight: "400", color: '#81878C' }} >
            User type
          </div>
          <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'start', justifyContent: 'start', }}>
            <div style={{ height: '24px', marginTop: '8px', marginBottom: '4px', paddingLeft: '8px', paddingRight: '8px', borderRadius: '6px', display: 'flex', justifyContent: "center", alignItems: "center", backgroundColor: '#FFDCE2' }}>
              <div style={{ fontSize: "15px", fontWeight: "500", color: '#842234' }}>{profileDetails['role'] ?? '---'}</div>
            </div>
          </div>
          <div style={{ flex: 1, marginTop: '8px', display: 'flex', flexDirection: 'row', alignItems: 'start', justifyContent: 'start', }}>
            <div onClick={() => { setIsOpen(true); }} style={{ height: '44px', marginLeft: '8px', marginRight: '8px', borderRadius: '8px', display: 'flex', flex: 1, justifyContent: "center", alignItems: "center", border: "1px solid #E5E5E5", }}>
              <div style={{ fontSize: "14px", fontWeight: "700", color: '#FF4444' }}>Logout</div>
            </div>

          </div>
        </div>

        &nbsp;&nbsp;

      </Col>
    </Row>
    {isOpen && (
      <div style={modalStyle.overlay} backdrop="static">
        <div ref={alertRef} style={modalStyle.modal}>
          <div style={{ color: '#ffffff' }}>
            <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center', }}>
              <div style={{ fontSize: "20px", fontWeight: "700", color: '#1E1E1E' }}>Logout</div>
              <div style={{ marginTop: '8px', fontSize: "16px", fontWeight: "400", color: '#1E1E1E' }}>You won’t able to access your logs after logging out. Are you sure want to log out?</div>

              <div style={{ flex: 12, marginTop: '8px', display: 'flex', flexDirection: 'row', alignItems: 'start', justifyContent: 'start', }}>
                <div onClick={() => { setIsOpen(false); }} style={{ width: '158px', height: '44px', marginLeft: '8px', marginRight: '8px', borderRadius: '8px', display: 'flex', flex: 6, justifyContent: "center", alignItems: "center", border: "1px solid #E5E5E5", }}>
                  <div style={{ fontSize: "16px", fontWeight: "500", color: '#1E1E1E' }}>Stay as logged in</div>
                </div>
                <div onClick={() => {
                  const currentURL = window.location.href;

                  const redirectData = {
                    redirectPath: currentURL,
                    app: "meetq",
                    ts: Date.now(),
                  };

                  console.warn("🔐 Saving redirect in window.name:", redirectData);

                  // ✅ TAB-SPECIFIC, CROSS-DOMAIN SAFE
                  window.name = JSON.stringify(redirectData);
                  document.cookie = "mawalog=; path=/; domain=.mawalog.com";
                  window.location.href = `${accountsUrl}/login`;
                }} style={{ width: '158px', height: '44px', marginLeft: '8px', marginRight: '8px', borderRadius: '8px', display: 'flex', flex: 6, justifyContent: "center", alignItems: "center", background: "#FF4444", }}>
                  <div style={{ fontSize: "16px", fontWeight: "500", color: '#FFFFFF' }}>Log Out</div>
                </div>

              </div>
            </div>

          </div>
        </div>
      </div>
    )}
    {/*  <Modal ref={alertRef}  show={isOpen} onHide={closeModal} backdrop="static">
        <Modal.Header closeButton>
          <Modal.Title>Modal Title</Modal.Title>
        </Modal.Header>
        <Modal.Body>This is the modal body content.</Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={closeModal}>
            Close
          </Button>
        </Modal.Footer>
      </Modal> */}
    <LoaderModal show={loading} />
  </Container>)



}